import { createReducer } from '@reduxjs/toolkit'
import { resetFiltreOrgans, setFiltreOrgans } from '../actions/FiltreOrgansAction'
import { Filtre } from 'models'

export type FiltreOrgansType = Pick<Filtre, 'nomOrgan'>

const initialFiltreOrgans: FiltreOrgansType = {
  nomOrgan: ''
}

const filtreOrgansReducer = createReducer(initialFiltreOrgans, (builder) => {
  builder
    .addCase(resetFiltreOrgans, () => {
      return initialFiltreOrgans
    })
    .addCase(setFiltreOrgans, (_state, action) => {
      return action.payload
    })
})

export default filtreOrgansReducer
